export default __webpack_public_path__ + "static/media/twitter.a5950f2a.svg";